





window.TestFunction = function(sectionName)
{
    //console.log("CallDefaultFunction called with:", sectionName);

    // your existing logic here
    // ...
    const hotelTitle = document.getElementById("HotelTitle");
    const navbarTitle = document.getElementById("NavbarTitle");

    const bookingSection = document.getElementById("BookingSection");
    const stickyBooking = document.getElementById("StickyBookingBar");

    const hotelObserver = new IntersectionObserver(
    ([entry]) =>
    {
        if(entry.isIntersecting)
        {
            navbarTitle.innerHTML = "";
        }
        else
        {
            navbarTitle.innerHTML = "D'Limasan Cottage";
        }
    },
    {
        threshold:0
    });

    hotelObserver.observe(hotelTitle);


    const bookingObserver = new IntersectionObserver(
    ([entry]) =>
    {
        if(entry.isIntersecting)
        {
            stickyBooking.classList.remove("Show");
        }
        else
        {
            stickyBooking.classList.add("Show");
        }
    },
    {
        threshold:0
    });

    bookingObserver.observe(bookingSection);
    
};


